const state = {
  is_show_ployline: false,
};

const mutations = {
  updatePstatus(state, status) {
    state.is_show_ployline = status;
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
